module.exports = __webpack_public_path__ + "static/media/image2.3f2f4da9.png";